const cookieMonster = {
  cookieName() {
    return 'COOKIECONSENT';
  },
  expireDate() {
    const expireInDays = 30;
    return (new Date()).getTime() + 86400000 * expireInDays;
  },
  acceptAll() {
    let cookies = {};
    cookies.other = true;
    cookies.tracking = true;
    cookies.marketing = true;
    return cookies;
  },
  rejectAll() {
    let cookies = {};
    cookies.other = false;
    cookies.tracking = false;
    cookies.marketing = false;
    return cookies;
  },
  getAll() {
    let cookies = {};

    document.cookie
      .split(';')
      .filter(cookieString => {
        return cookieString !== '';
      })
      .map(cookieString => {
        cookies[cookieString.trim().replace(/^([^=]*)=(.*)/, '$1')] = cookieString.trim().replace(/^([^=]*)=(.*)/, '$2');
    });

    return cookies;
  },
  get(cookieName) {
    return this.getAll()[cookieName];
  },
  set(cookieValue) {
    document.cookie = `${this.cookieName()}=${cookieValue}${this.expireDate() ? '; expires=' + this.expireDate() + '; path=/' : ''}`;
  },
  eat(cookieName) {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname}`;
  },
  delete(cookieName) {
    document.cookie = cookieName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  },
};

export default cookieMonster;
